/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Account_CreatedInputs */



/**
* | output |
* | --- |
* | "Account created! Please check your email and verify your account before signing in." |
*
* @param {Login_Success_Account_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_account_created = /** @type {((inputs?: Login_Success_Account_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Account_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte créé ! Veuillez vérifier votre email et vérifier votre compte avant de vous connecter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto erstellt! Bitte überprüfen Sie Ihre E-Mails und bestätigen Sie Ihr Konto, bevor Sie sich anmelden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Account creato! Controlla la tua email e verifica il tuo account prima di accedere.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Учетная запись создана! Пожалуйста, проверьте свою электронную почту и подтвердите свою учетную запись перед входом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Cuenta creada! Revisa tu correo electrónico y verifica tu cuenta antes de iniciar sesión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("账户已创建！请检查您的电子邮件并验证您的账户后再登录。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウントが作成されました。サインインする前に、メールを確認し、アカウントを確認してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाता बन गया! कृपया लॉग इन करने से पहले अपना ईमेल चेक करें और अपना खाता सत्यापित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conta criada! Por favor, verifique seu e-mail e confirme sua conta antes de entrar.")
	return /** @type {LocalizedString} */ ("Account created! Please check your email and verify your account before signing in.")
});